import React from 'react'
import styled from 'styled-components'
import { Heading1 } from 'adl'
import Iframe from 'react-iframe'

import StandardLayout from 'components/layouts/Standard'

const MyIframe = styled(Iframe)`
  border: none !important;
`

export default () => {
  const demoLink = `https://salesdemo.local/Bluepoint.ECM.WebShare/#?m=1000&t=5/21/2020 5:18:47 PM&h=28hmFcYQGT9B2P4g_0mCzdxnwVLsWNBF3FA8R8uTAPM9KpKDSz_sHgmHPEiBtbSA_QX2ojOw8zu8aXquHfpeZg`
  return (
    <StandardLayout>
      <Heading1>Statements & Documents</Heading1>
      <div style={{ maxWidth: 768, position: 'relative' }}></div>
      <MyIframe
        url={demoLink}
        width="100%"
        height="800px"
        id="fastdocs-iframe"
        display="initial"
        position="relative"
        style={{
          borderTopWidth: 0,
          borderLeftWidth: 0,
          borderRightWidth: 0,
          borderBottomWidth: 0
        }}
      />
    </StandardLayout>
  )
}
